export default __webpack_public_path__ + "static/media/JordanWebsiteLogo.36c7ed3b.png";